import ModalDestructiveConfirm from 'components/ModalDestructiveConfirm';
import {FC} from 'react';
import {useForm} from 'react-hook-form';
import {useBackend} from 'state/backend';
import {t} from 'ttag';
import {FormFields} from 'types/utils';
import {onApiError} from 'utils/request-axios/utils';

import {useDeleteTag} from '../services';
import {Tag} from '../types';

type DeleteTagModalProps = {
    isOpen: boolean;
    onClose: () => void;
    tag: Tag;
};

type FormData = FormFields<{id: number}>;

const DeleteTagModal: FC<DeleteTagModalProps> = ({isOpen, onClose, tag}) => {
    const {refreshData} = useBackend();
    const {mutateAsync} = useDeleteTag();
    const methods = useForm<FormData>();

    const onConfirmDelete = () => {
        mutateAsync({id: tag.id})
            .then(() => {
                refreshData(window.Urls.partner_tags_view());
                onClose();
            })
            .catch((error) => {
                onApiError(methods)(error);
            });
    };

    return (
        <ModalDestructiveConfirm
            header={t`Are you sure you want to delete this tag?`}
            isOpen={isOpen}
            onCancel={onClose}
            onConfirm={onConfirmDelete}
        >
            <p className="break-words">
                {tag.itemCount === 0 &&
                    t`There are currently no documents tagged "${tag.name}"`}
                {tag.itemCount === 1 &&
                    t`There is currently 1 document tagged "${tag.name}". Deleting this tag will remove it from this document, but the document won\'t be deleted.`}
                {tag.itemCount > 1 &&
                    t`There are currently ${tag.itemCount} documents tagged "${tag.name}". Deleting this tag will remove it from these documents, but the documents won\'t be deleted.`}
            </p>
        </ModalDestructiveConfirm>
    );
};

export default DeleteTagModal;
